class NewsLetterWindow extends HTMLElement {
  constructor() {
    super();
    this.customer = this.getAttribute('data-customer-logged-in');
    this.delayBeforeDisplay = +this.getAttribute('data-delay-before-display');
    this.closeBtn = this.querySelectorAll('.js-newsletter-window__close');
    this.windowHolder = this.closest('.newsletter-window-holder');
    this.triggerOpenModalWindow = document.querySelectorAll('.js-trigger-newsletter-modal');
    this.buttonCloseModalWindow = this.querySelector('.js-newsletter-window__button-close');
    this.KEY_DATA_VALUE = 'dataNewsletterWindow';

    const baseData = {
      'isFirstShowWindow': true,
      'isSuccess': false,
      'isFirstShowSuccessWindow': false,
    };

    if (this.getDataWindow() === null) {
      this.setDataWindow(baseData);
    }

    if (this.customer === 'true') return

    this.render();
  }

  showButtonTrigger() {
    this.triggerOpenModalWindow.forEach(item => item.classList.remove('hidden'))
  }

  getDataWindow() {
    return JSON.parse(localStorage.getItem(this.KEY_DATA_VALUE));
  }

  setDataWindow(data) {
    return localStorage.setItem(this.KEY_DATA_VALUE, JSON.stringify(data));
  }

  getValueDataWindow(key) {
    const data = JSON.parse(localStorage.getItem(this.KEY_DATA_VALUE));
    return data[key];
  }

  setValueDataWindow(key, value) {
    const data = this.getDataWindow();
    data[key] = value;

    this.setDataWindow(data);
  }

  closeWindow() {
    this.windowHolder.classList.remove('show');
    this.windowHolder.classList.add('close');
    this.showButtonTrigger();
    this.setValueDataWindow('isFirstShowSuccessWindow', false);
  }

  showWindow() {
    this.windowHolder.classList.remove('close');
    this.windowHolder.classList.add('show');
    this.triggerOpenModalWindow[0]?.classList.add("hidden");
    this.setValueDataWindow('isFirstShowWindow', false);
  }

  attachEvents() {
    this.closeBtn.forEach(item => item.addEventListener('click', () => this.closeWindow()));

    this.triggerOpenModalWindow.forEach(item => {
      item.addEventListener('click', () => {
        item.classList.add('hidden')
        this.showWindow();
      })
    });

    document.addEventListener('click', (e) => {
      const target = e.target;

      if (!target.closest('.newsletter-window') && target.closest('.newsletter-window-holder')) {
        this.closeWindow();
      }
    });
  }

  showSuccessMessage() {
    const newsletterFormContainer = this.querySelector('.js-newsletter-form__field-wrapper');
    const successMessageContainer = this.querySelector('.js-newsletter-form__successfull-message');

    if (this.getValueDataWindow('isSuccess') === true) {
      newsletterFormContainer?.classList.add('d-none');
      successMessageContainer?.classList.remove('d-none');
      this.buttonCloseModalWindow?.classList.remove('d-none');
    }
  }

  render() {
    const delay = this.delayBeforeDisplay * 10_000;
    this.attachEvents();
    this.showSuccessMessage();

    // first show modal window message
    if (this.getValueDataWindow('isFirstShowWindow')) {
      setTimeout(() => this.showWindow(), delay);
    }

    // If the button is disabled, the modal window will be displayed on every page refresh.
    if (!this.triggerOpenModalWindow.length) {
      setTimeout(() => this.showWindow(), delay);
    }

    //Display the message immediately after a successful submission
    if (this.getValueDataWindow('isFirstShowSuccessWindow') && this.getValueDataWindow('isSuccess')) {
      this.showWindow();
    }
  }
}

customElements.define('newsletter-window', NewsLetterWindow);
